import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'dashboard', loadChildren: () => import('app/modules/general/dashboard/dashboard.routes')},
            {path: 'certification', loadChildren: () => import('app/modules/general/certification/certification-list/certification-list.routes')},
            {path: 'certification/explanation', loadChildren: () => import('app/modules/general/certification/certification.routes')},
            {path: 'certification/questioner', loadChildren: () => import('app/modules/general/certification/questioner/questioner.routes')},
            {path: 'certification/details/:id', loadChildren: () => import('app/modules/general/certification/questioner/result-details/result-details.routes')},
            {path: 'users', loadChildren: () => import('app/modules/general/users/users.routes')},
            {path: 'licences', loadChildren: () => import('app/modules/admin/licences/licences.routes')},
            {path: 'settings/server-info', loadChildren: () => import('app/modules/admin/server-info/server-info.routes')},
            {path: 'settings/smtp', loadChildren: () => import('app/modules/admin/smtp/smtp.routes')},
            {path: 'settings/backup', loadChildren: () => import('app/modules/admin/backup/backup.routes')},
            {path: 'file-manager', loadChildren: () => import('app/modules/general/file-manager/file-manager.routes')},
            {path: 'profile', loadChildren: () => import('app/modules/general/profile/profile.routes')},
            {path: 'companies', loadChildren: () => import('app/modules/admin/companies/companies.routes')}
        ]
    }
];
